<template>
  <div>
    <button class="btn btn-sm btn-info " 
      @click="downloadItem({url, name: name})">
      <slot></slot>
    </button>
  </div>
</template>
<script>
  export default{
    props: {
      name: {
        default: "",
      },
      url: {
        default: "",
      },
      params:{
        default: function(){
          return {};
        }
      },
    },
    // props:["url", "name", "params"],
    data(){
      return {

      }
    },
    mounted(){
      console.log(this.params)
    },
    methods:{
      downloadItem({ url, name }) {
        let params = {}
        if(this.params)
          params = this.params
        this.$http
          .get(url, { 
            responseType: 'blob', 
            params 
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = name;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      },
    }
  }
</script>